import BasePaginatedCollection from "@/core/classes/base/BasePaginatedCollection";
import JobField from "./JobField.js";

export default class PaginatedJobFieldCollection extends BasePaginatedCollection {
  constructor(paginationResponse) {
    super(paginationResponse);
    paginationResponse?.data.map(field => {
      this.collection.push(new JobField(field));
    });
  }
  updatePaginationPage(paginationResponse) {
    super.updatePaginationPage(paginationResponse);
    paginationResponse.data.map(field => {
      this.collection.push(new JobField(field));
    });
  }
}
